var map = {
	"./analista-de-dados.jpg": 1071,
	"./cientista-de-dados.jpg": 1072,
	"./copywriting.jpg": 1073,
	"./design-grafico.jpg": 1074,
	"./designer-de-interiores.jpg": 1075,
	"./designer-grafico.jpg": 1076,
	"./fashion-business.jpg": 1077,
	"./fashion-design.jpg": 1078,
	"./fotografia.jpg": 1079,
	"./full-stack-java.jpg": 1080,
	"./full-stack-python.jpg": 1081,
	"./it-start.jpg": 1082,
	"./marketing-digital.jpg": 1083,
	"./mkt-start.jpg": 1084,
	"./personal-stylist.jpg": 1085,
	"./power-bi.jpg": 1086,
	"./roteiro.jpg": 1087,
	"./uxui-designer.jpg": 1088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1490;